/*
 * File: catalog-cloud.module.ts                                               *
 * Project: catalog-cloud                                                      *
 * File Created: Friday, 2nd December 2022 14:33:51                            *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Monday, 6th March 2023 09:59:20                              *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";


import { BrowserModule } from '@angular/platform-browser';    // BrowserModule (sin cambios, este es nativo de Angular)
import { RouterModule } from '@angular/router';               // RouterModule (sin cambios, este es nativo de Angular)

import { TableModule } from 'primeng/table';                  // MatTableModule
import { TabViewModule } from 'primeng/tabview';              // MatTabsModule
import { InputTextModule } from 'primeng/inputtext';          // MatInputModule
import { CardModule } from 'primeng/card';                    // MatCardModule
import { DropdownModule } from 'primeng/dropdown';            // MatOptionModule y MatSelectModule
import { CheckboxModule } from 'primeng/checkbox';            // MatCheckboxModule
import { InputSwitchModule } from 'primeng/inputswitch';      // MatSlideToggleModule
import { ButtonModule } from 'primeng/button';                // MatButtonModule
import { ToggleButtonModule } from 'primeng/togglebutton';    // MatButtonToggleModule
import { TooltipModule } from 'primeng/tooltip';              // MatTooltipModule
import { ListboxModule } from 'primeng/listbox';              // MatListModule
import { ProgressSpinnerModule } from 'primeng/progressspinner'; // MatProgressSpinnerModule
import { CalendarModule } from 'primeng/calendar';            // MatDatepickerModule
import { DividerModule } from "primeng/divider";
import { TieredMenuModule } from 'primeng/tieredmenu';
import { TreeTableModule } from 'primeng/treetable';
import { ChipModule } from 'primeng/chip';
import { SelectButtonModule } from 'primeng/selectbutton';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';

import { PrimeFormGeneratorModule } from "@nousmedis/ngx-primeng-generator";
import { FormlyModule } from "@ngx-formly/core";
import { FormlyPrimeNGModule } from "@ngx-formly/primeng";
import { RepeatSectionComponent } from "./components/catalog/catalog-form/repeat-section.type";
import { BreadCrumbModule } from "../breadcrumbs/breadcrumbs.module";
import { CatalogActionMenuComponent } from "./components/catalog/catalog-action-menu/catalog-action-menu.component";
import { CatalogDeleteComponent } from "./components/catalog/catalog-delete/catalog-delete.component";
import { CatalogFormComponent } from "./components/catalog/catalog-form/catalog-form.component";
import { CatalogHomeComponent } from "./components/catalog/catalog-home/catalog-home.component";
import { CatalogListComponent } from "./components/catalog/catalog-list/catalog-list.component";
import { CatalogSyncComponent } from "./components/catalog/catalog-sync/catalog-sync.component";
import { CatalogFormEditComponent } from "./components/catalog/catalog-form-edit/catalog-form-edit.component";
import { CatalogUploadComponent } from "./components/catalog/catalog-upload/catalog-upload.component";
import { CatalogWizardComponent } from "./components/catalog/catalog-wizard/catalog-wizard.component";
import { CatalogWizardSyncComponent } from "./components/catalog/catalog-wizard-sync/catalog-wizard-sync.component";
import { CcCellComponent } from "./components/cell/cc-cell/cc-cell.component";
import { CcCellButtonComponent } from "./components/cell/cc-cell-button/cc-cell-button.component";
import { CcCellItemComponent } from "./components/cell/cc-cell-item/cc-cell-item.component";
import { CcCellItemExtraFieldsFormComponent } from "./components/cell/cc-cell-item-extra-fields-form/cc-cell-item-extra-fields-form.component";
import { CcCellItemModelSelectorComponent } from "./components/cell/cc-cell-item-model-selector/cc-cell-item-model-selector.component";
import { CcCellItemVariantSelectorComponent } from "./components/cell/cc-cell-item-variant-selector/cc-cell-item-variant-selector.component";
import { CcGridComponent } from "./components/grid/cc-grid/cc-grid.component";
import { CcGridSelectorComponent } from "./components/grid/cc-grid-selector/cc-grid-selector.component";
import { FascicleAskUnblockComponent } from "./components/fascicle/fascicle-ask-unblock/fascicle-ask-unblock.component";
import { FascicleBlockStatusComponent } from "./components/fascicle/fascicle-block-status/fascicle-block-status.component";
import { FascicleDeleteComponent } from "./components/fascicle/fascicle-delete/fascicle-delete.component";
import { FascicleEditComponent } from "./components/fascicle/fascicle-edit/fascicle-edit.component";
import { FascicleFormComponent } from "./components/fascicle/fascicle-form/fascicle-form.component";
import { FascicleListComponent } from "./components/fascicle/fascicle-list/fascicle-list.component";
import { FascicleListAloneComponent } from "./components/fascicle/fascicle-list-alone/fascicle-list-alone.component";
import { PageDeleteComponent } from "./components/page/page-delete/page-delete.component";
import { PageTemplateFormComponent } from "./components/page/page-template-form/page-template-form.component";
import { PageTemplateListComponent } from "./components/page/page-template-list/page-template-list.component";
import { ProductDetailsComponent } from "./components/product/product-details/product-details.component";
import { ProductFormComponent } from "./components/product/product-form/product-form.component";
import { ProductGridComponent } from "./components/product/product-grid/product-grid.component";
import { ProductGridItemComponent } from "./components/product/product-grid-item/product-grid-item.component";
import { ProductListComponent } from "./components/product/product-list/product-list.component";
import { ProductListItemComponent } from "./components/product/product-list-item/product-list-item.component";
import { ProductToolbarComponent } from "./components/product/product-toolbar/product-toolbar.component";
import { ProductToolbarProductDetailsComponent } from "./components/product/product-toolbar-product-details/product-toolbar-product-details.component";
import { ProductToolbarSearchComponent } from "./components/product/product-toolbar-search/product-toolbar-search.component";
import { ProductToolbarSearchInfoComponent } from "./components/product/product-toolbar-search-info/product-toolbar-search-info.component";
import { ProductDragPreviewComponent } from "./components/product/product-drag-preview/product-drag-preview.component";
import { TmsToolsModule } from "../tms-tools/tms-tools.module";
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { StepperModule } from 'primeng/stepper';
import { DialogModule } from "primeng/dialog";
import { DataViewModule } from 'primeng/dataview';
import { AccordionModule } from 'primeng/accordion';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SliderModule } from 'primeng/slider';
import { BadgeModule } from "primeng/badge";
import { InputTextareaModule } from 'primeng/inputtextarea';


import { MenuModule } from 'primeng/menu';                    
import { ProgressBarModule } from 'primeng/progressbar';      
import { PaginatorModule } from 'primeng/paginator';          
import { StepsModule } from 'primeng/steps';                  
import { SidebarModule } from 'primeng/sidebar';              
import { ChipsModule } from 'primeng/chips';                  
import { RadioButton, RadioButtonModule } from 'primeng/radiobutton';


import { DragDropModule as cdkDragDropModule } from "@angular/cdk/drag-drop";
import { DragDropModule } from "primeng/dragdrop";
import { MenusModule } from "../menus/menus.module";

import { TranslateModule } from "@ngx-translate/core";
import { FascicleService } from "./services/fascicle.service";
import { FieldMappingService } from "./services/field-mapping.service";
import { ConfirmationService } from "primeng/api";
import { PageTemplateExampleComponent } from "./components/page/page-template-example/page-template-example.component";
import { CcCellTemplateComponent } from "./components/cell/cc-cell-template/cc-cell-template.component";
import { CcCellTemplateButtonComponent } from "./components/cell/cc-cell-template-button/cc-cell-template-button.component";
import { AppLayoutModule } from "app/layout/app.layout.module";
import { ProductDetailsModalComponent } from "./components/product/product-details-modal/product-details-modal.component";
import { LazyBgDirective } from "./directives/lazy-bg.directive";
import { TagModule } from 'primeng/tag';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputNumberModule } from 'primeng/inputnumber';
import { FascicleAutoFormComponent } from "./components/fascicle/fascicle-auto-form/fascicle-auto-form.component";
import { PageTemplateInUseComponent } from "./components/page/page-template-in-use/page-template-in-use.component";
import { PageTemplateImportDialogComponent } from "./components/page/page-template-import-dialog/page-template-import-dialog.component";
import { SplitterModule } from 'primeng/splitter';
import { CatalogFormWizardComponent } from "./components/catalog/catalog-form-wizard/catalog-form-wizard.component";
import { ToastModule } from 'primeng/toast';
import { SplitButtonModule } from 'primeng/splitbutton';
import { MessageModule } from 'primeng/message';
import { TreeModule } from 'primeng/tree';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { FasciclePaginatorComponent } from "./components/fascicle/fascicle-paginator/fascicle-paginator.component";
import { CcCellAddNoteFormComponent } from "./components/cell/cc-cell-add-note-form/cc-cell-add-note-form.component";
import { CcCellDetailDialogComponent } from "./components/cell/cc-cell-detail-dialog/cc-cell-detail-dialog.component";
import { FascicleHistoryPanelComponent } from "./components/fascicle/fascicle-history-panel/fascicle-history-panel.component";
import { FieldMappingEditorComponent } from "./components/catalog/field-mapping-editor/field-mapping-editor.component";
import { CatalogIndexComponent } from "./components/catalog/catalog-index/catalog-index.component";


@NgModule({
    imports: [
        MenuModule,
        ProgressBarModule,
        PaginatorModule,
        StepsModule,
        SidebarModule,
        DividerModule,
        ChipsModule,
        RadioButtonModule,
        BreadCrumbModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserModule,
        RouterModule,
        TableModule,
        TreeTableModule,
        TabViewModule,
        InputTextModule,
        CardModule,
        DropdownModule,
        CheckboxModule,
        InputSwitchModule,
        ButtonModule,
        ToggleButtonModule,
        TooltipModule,
        InputGroupModule,
        InputGroupAddonModule,
        IconFieldModule,
        InputIconModule,
        ListboxModule,
        ProgressSpinnerModule,
        CalendarModule,
        TranslateModule,
        DragDropModule,
        TmsToolsModule,
        MenusModule,
        DynamicDialogModule,
        DialogModule,
        MultiSelectModule,
        StepperModule,
        ChipModule,
        SelectButtonModule,
        DataViewModule,
        PrimeFormGeneratorModule,
        ConfirmDialogModule,
        AccordionModule,
        TieredMenuModule,
        SliderModule,
        BadgeModule,
        cdkDragDropModule,
        BreadCrumbModule,
        TagModule,
        SplitterModule,
        ToastModule,
        SplitButtonModule,
        MessageModule,
        TreeModule,
        OverlayPanelModule,
        InputTextareaModule,
        InputNumberModule,
        FormlyPrimeNGModule,
        FormlyModule.forChild({
            types: [{ name: 'repeat', component: RepeatSectionComponent }],
        }),
    ],
    declarations: [
        CatalogActionMenuComponent,
        CatalogDeleteComponent,
        CatalogFormComponent,
        CatalogHomeComponent,
        CatalogListComponent,
        CatalogSyncComponent,
        CatalogFormEditComponent,
        CatalogUploadComponent,
        CatalogWizardComponent,
        CatalogWizardSyncComponent,
        CcCellComponent,
        CcCellTemplateComponent,
        CcCellButtonComponent,
        CcCellTemplateButtonComponent,
        CcCellItemComponent,
        CcCellItemExtraFieldsFormComponent,
        CcCellItemModelSelectorComponent,
        CcCellItemVariantSelectorComponent,
        CcCellAddNoteFormComponent,
        CcCellDetailDialogComponent,
        FascicleHistoryPanelComponent,
        CcGridComponent,
        CcGridSelectorComponent,
        FascicleAskUnblockComponent,
        FascicleBlockStatusComponent,
        FascicleDeleteComponent,
        FascicleEditComponent,
        FascicleFormComponent,
        FascicleListComponent,
        FascicleListAloneComponent,
        FasciclePaginatorComponent,
        PageDeleteComponent,
        PageTemplateFormComponent,
        PageTemplateListComponent,
        PageTemplateExampleComponent,
        ProductDetailsComponent,
        ProductFormComponent,
        ProductGridComponent,
        ProductGridItemComponent,
        ProductListComponent,
        ProductListItemComponent,
        ProductToolbarComponent,
        ProductToolbarProductDetailsComponent,
        ProductToolbarSearchComponent,
        ProductToolbarSearchInfoComponent,
        ProductDetailsModalComponent,
        LazyBgDirective,
        FascicleAutoFormComponent,
        PageTemplateInUseComponent,
        PageTemplateImportDialogComponent,
        CatalogFormWizardComponent,
        ProductDragPreviewComponent,
        RepeatSectionComponent,
        FieldMappingEditorComponent,
        CatalogIndexComponent,
    ],
    exports: [
        ProductToolbarComponent,
    ],
    providers: [ConfirmationService, FieldMappingService],
})
export class CatalogCloudModule { }


